import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

import type { Catalog } from '@/catalog/types'
import { EMPTY_CATALOG, fetchCatalog } from '@/lib/apiCatalog'

// Empty default so consumers render synchronously while GET /api/catalog loads.
const CatalogContext = createContext<Catalog>(EMPTY_CATALOG)

export function CatalogProvider({ children }: { children: ReactNode }) {
  const [catalog, setCatalog] = useState<Catalog>(EMPTY_CATALOG)

  useEffect(() => {
    let alive = true
    fetchCatalog()
      .then((c) => {
        if (alive) setCatalog(c)
      })
      .catch(() => {
        /* keep EMPTY_CATALOG on failure */
      })
    return () => {
      alive = false
    }
  }, [])

  return <CatalogContext.Provider value={catalog}>{children}</CatalogContext.Provider>
}

export function useCatalog(): Catalog {
  return useContext(CatalogContext)
}

export function useProduct(key: string) {
  const catalog = useCatalog()
  return catalog.products.find((p) => p.key === key)
}
